import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Agent, AgentVersion } from '../models/agent';
import { Observable } from 'rxjs';
import { BaseApiService } from './base.service';
import { map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class AgentsService extends BaseApiService {

  constructor(http: HttpClient) {
    super(http, 'agents');
  }

  getModels(): Observable<string[]> {
    return this._http.get(this._baseUrl + '/models').pipe(
      map((res: any) => res?.models || [])
    );
  }

  getAgent(name: string): Observable<Agent> {
    return this._http.get<Agent>(this._baseUrl + `/${name}`);
  }

  getAgentVersions(name: string): Observable<AgentVersion[]> {
   return this._http.get<AgentVersion[]>(this._baseUrl + `/${name}/versions`);
  }

  getAgentByVersionId(name: string, id: number): Observable<Agent> {
    return this._http.get<Agent>(this._baseUrl + `/${name}/versions/${id}`);
  }

  deployAgent(name: string, data: any): Observable<any> {
    const params = { ...data };
    return this._http.post(this._baseUrl + `/${name}/deploy`, params);
  }

}
